var _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "action-window/link",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.47444 11.5256C8.91804 11.9475 8.91804 12.64 8.47444 13.0619C8.05247 13.4839 7.36002 13.4839 6.93806 13.0619C4.82824 10.9521 4.82824 7.52232 6.93806 5.4125L10.7682 1.58236C12.878 -0.527455 16.3078 -0.527455 18.4176 1.58236C20.5275 3.69218 20.5275 7.12199 18.4176 9.23181L16.8055 10.8439C16.8163 9.95672 16.6757 9.06952 16.3727 8.22559L16.8813 7.70625C18.158 6.44036 18.158 4.38464 16.8813 3.11874C15.6154 1.84203 13.5596 1.84203 12.2938 3.11874L8.47444 6.93806C7.19773 8.20395 7.19773 10.2597 8.47444 11.5256ZM11.5256 6.93806C11.9475 6.51609 12.64 6.51609 13.0619 6.93806C15.1718 9.04788 15.1718 12.4777 13.0619 14.5875L9.23181 18.4176C7.12199 20.5275 3.69218 20.5275 1.58236 18.4176C-0.527455 16.3078 -0.527455 12.878 1.58236 10.7682L3.19448 9.15607C3.18366 10.0433 3.32432 10.9305 3.62727 11.7852L3.11874 12.2938C1.84203 13.5596 1.84203 15.6154 3.11874 16.8813C4.38464 18.158 6.44036 18.158 7.70625 16.8813L11.5256 13.0619C12.8023 11.7961 12.8023 9.74033 11.5256 8.47444C11.082 8.05247 11.082 7.36002 11.5256 6.93806Z",
    fill: "#5D6B72"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#action-window/link)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 24,
    height: 24,
    fill: "#54AF48"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.9b88f1bc.svg";
export { ForwardRef as ReactComponent };